import React, { Component } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";

export default class HotelRoomStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      showModal: false,
      newItem: { code: "", description: "" },
      editItem: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const res = await fetch(process.env.REACT_APP_API + "HotelRoomStatus");
    const data = await res.json();
    this.setState({ items: data });
  }

  handleShowModal = (item = null) => {
    this.setState({
      showModal: true,
      editItem: item,
      newItem: item || { code: "", description: "" },
    });
  };

  handleCloseModal = () => this.setState({ showModal: false, editItem: null });

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      newItem: { ...prev.newItem, [name]: value },
    }));
  };

  handleSave = async () => {
    const { editItem, newItem } = this.state;
    const api = process.env.REACT_APP_API + "HotelRoomStatus";
    const method = editItem ? "PUT" : "POST";
    const url = editItem ? `${api}/${editItem.roomStatusId}` : api;

    await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        roomStatusId: editItem ? editItem.roomStatusId : undefined,
        code: newItem.code,
        description: newItem.description,
      }),
    });

    this.handleCloseModal();
    this.loadData();
  };

  handleDelete = async (id) => {
    if (!window.confirm("Delete this status?")) return;
    await fetch(process.env.REACT_APP_API + "HotelRoomStatus/" + id, {
      method: "DELETE",
    });
    this.loadData();
  };

  render() {
    const { items, showModal, newItem, editItem } = this.state;

    return (
      <div className="container mt-4">
        <h4>Hotel Room Status</h4>
        <Button
          variant="primary"
          className="mb-3"
          onClick={() => this.handleShowModal()}
        >
          Add Status
        </Button>

        <Table bordered hover>
          <thead>
            <tr>
              <th>Code</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.roomStatusId}>
                <td>{s.code}</td>
                <td>{s.description}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.handleShowModal(s)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => this.handleDelete(s.roomStatusId)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {editItem ? "Edit Room Status" : "Add Room Status"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Code</Form.Label>
                <Form.Control
                  name="code"
                  value={newItem.code}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  value={newItem.description}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleSave}>
              {editItem ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
